import React from 'react';

export const ConvertirSaltosDeLinea = (texto) => {
  return texto.split(/\r\n|\n/).map((linea, index) => (
    <React.Fragment key={index}>
      {linea}
      <br />
    </React.Fragment>
  ));
};
